import typography from "app/assets/theme/base/typography";
import React, { useEffect, useState } from "react";
import { useTheme } from "../../common/ProjectThemeProvider";
import { ModuleRouteUrls, Modules } from "../config/AppConfig";
import { Anchor, Flexbox } from "../../common/fusion-ui";
import { display } from "@mui/system";

const AppFooter = React.memo(() => {
    const { size } = typography;
    const theme = useTheme();
    const termOfuseModule = Modules.TermsOfUse
    const termOfUseModuleRoute = ModuleRouteUrls[termOfuseModule]
    const legalModule = Modules.Legal
    const legalModuleRoute = ModuleRouteUrls[legalModule]

    useEffect(() => {
    }, [])


    {/* Added by Vandit Tewari (28/10/2024) - Added this to dynamically change width of screen on change and according to it below div display to make it responsive design*/}
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const updateWidth = () => {
        setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateWidth);


    return (
        <div className={'w-100 py-1 pb-2x mt-2'}
            style={{ backgroundColor: theme.primary20, color: theme.primaryDark }}>
            <Flexbox
                directionMd={'column'}
                directionSm={'column'}
                alignAt="center"
                justifyAt="between"
                style={{}}
            >
                {/* Contact: Medical Services */}
                <span className=" ms-2">Contact: Medical Services</span>

                {/* Center content */}
                <Flexbox
                    justifyAt="center"
                    alignAt="center">
                    <span className="">&copy; {new Date().getFullYear()}</span>, <span className="">Sanofi Pasteur India</span>
                    <i className="material-icons">
                        favorite
                    </i>

                    {/* Updated by Vandit Tewari (28/10/2024) - Added style in both bcz in phone flex making it inresponsive and cannout change flex direction from top as it is using an univbersal style that's why added it to remove and render below part in phones */}
                    {/* term of use */}
                    <Anchor
                        className={' footer-link-hover ms-2'}
                        asLink={false}
                        style={{ display: windowWidth < 427 ? 'none' : '' }}
                        href={termOfUseModuleRoute}>
                        <span className="">{termOfuseModule}</span>
                    </Anchor>

                    {/* Legal  */}
                    <Anchor
                        className={' footer-link-hover ms-2'}
                        asLink={false}
                        style={{ display: windowWidth < 427 ? 'none' : '' }}
                        href={legalModuleRoute}>
                        <span className="">{legalModule}</span>
                    </Anchor>

                    {/* {renderLinks()}  */}
                </Flexbox>

                {/* Added by Vandit Tewari (28/10/2024) - Added this copy of up diffrence outside of flexbox so comes in next row */}
                <div style={{ display: windowWidth < 427 ? 'flex' : 'none' }}>
                    {/* term of use */}
                    <Anchor
                        className={' footer-link-hover ms-2'}
                        asLink={false}
                        href={termOfUseModuleRoute}>
                        <span className="">{termOfuseModule}</span>
                    </Anchor>

                    {/* Legal  */}
                    <Anchor
                        className={' footer-link-hover ms-2'}
                        asLink={false}
                        href={legalModuleRoute}>
                        <span className="">{legalModule}</span>
                    </Anchor>
                </div>

                {/* Update: Tue, 23-May-2023 */}
                <span className=" me-2">Update: Tue, 23-May-2023</span>
            </Flexbox >
        </div >
    );
});

export default AppFooter;
